import type { Logger } from "@expert/logging";
import type { KyInstance } from "ky";

import type { SalesAnalyticsDispatcher } from "../sales-context/SalesContext.types";

interface CreateCaseRequestBody {
    email?: string;
    firstName?: string;
    lastName?: string;
    product: string;
    feature: string;
    callId: string;
}

export const createCase = async (
    client: KyInstance,
    logger: Logger,
    dispatcher: SalesAnalyticsDispatcher,
    request: CreateCaseRequestBody,
): Promise<{ caseId: string; caseNumber: string } | null> => {
    try {
        const response = await client
            .post("v1/case", { json: request, retry: 0 })
            .json<{ caseId: string; caseNumber: string }>();

        void dispatcher.dispatchBusinessEvent("CaseCreated", {
            caseId: response.caseId,
            caseNumber: response.caseNumber,
        });

        return response;
    } catch (error: unknown) {
        logger.warn({ error }, "case creation failed");
        return null;
    }
};
